import type { Project } from '../types/project'

export const projects: Project[] = [
  {
    id: 2,
    title: 'Movement and Psychedelics Research',
    description:
      'A scientific collaboration between Tel Aviv University, Ichilov Hospital, and Gaga People',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/tWbsjp8KZqAdg3uuVwwK4r/movement-for-web.png',
  },
  {
    id: 3,
    title: 'Research Workshops and Conferences',
    description:
      'Support for the Lorenz Center Workshop on Set and Setting and the International Conference on Psychedelic Research 2024 and 2026',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/bGuAnCyiE9M1PKHi29NRWs/conf-support-for-web.png',
    link: 'https://www.icpr-conference.com/partners',
    isExternal: true,
  },
  {
    id: 4,
    title: 'Origins of Consciousness',
    description:
      'Underwater archaeological expedition in search of evidence of psychedelics in ancient shipwrecks',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/7qEjTuxqtvdFLoooxNNavF/underwater-sub-for-web.jpg',
    link: '/projects/origins-of-consciousness',
    isExternal: false,
  },
]
